import React, { useState } from 'react';
import TabbedViewWithDateSelect from '../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect';
import { JLR_PLANT } from '../../constants';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import SubAssembly from '../SubAssembly/SubAssembly';

const SubAssemblyConfigurator = () => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [subAssemblyCount, setSubAssemblyCount] = useState(0);

  const title = 'Sub Assembly Configurator';

  return (
    <div>
      <TabbedViewWithDateSelect
        tabs={[
          {
            label: 'Sub Assembly',
            title,
            count: subAssemblyCount,
            countColor: plant.label === JLR_PLANT ? 'green' : 'blue',
            backgroundColor:
              plant.label === JLR_PLANT ? 'green' : 'blue',
            component: SubAssembly,
            props: {
              handleCountChange: setSubAssemblyCount,
            },
          },
        ]}
        pageTitle={title}
      />
    </div>
  );
};

export default SubAssemblyConfigurator;
